/* ------------------------------------------------------------------
   StudioForty9 Excellence in Ecommerce Conference — shared behaviour.
   Countdown clocks and reveal-on-scroll. Loaded once from
   snippets/conference-head.liquid. No third-party dependencies: the
   page must never rely on a CDN script to be readable.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function startCountdown(el) {
    var target = Date.parse(el.dataset.cfCountdown);
    if (isNaN(target)) {
      el.setAttribute('hidden', 'hidden');
      return;
    }

    var parts = {
      days: el.querySelector('[data-cf-days]'),
      hours: el.querySelector('[data-cf-hours]'),
      mins: el.querySelector('[data-cf-mins]'),
      secs: el.querySelector('[data-cf-secs]')
    };

    function tick() {
      var remaining = target - Date.now();
      if (remaining <= 0) {
        el.setAttribute('data-cf-expired', 'true');
        remaining = 0;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      if (parts.days) parts.days.textContent = pad(days);
      if (parts.hours) parts.hours.textContent = pad(hours);
      if (parts.mins) parts.mins.textContent = pad(mins);
      if (parts.secs) parts.secs.textContent = pad(secs);

      if (remaining > 0) window.setTimeout(tick, 1000);
    }

    tick();
  }

  function initReveals(root) {
    var nodes = root.querySelectorAll('[data-cf-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(nodes, function (node) {
      observer.observe(node);
    });
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cf-countdown]'), startCountdown);
    initReveals(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run for a section that was just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
